import { useScrollToTop } from 'expo-router';
import Loading from '../Loading/Loading';
import React, { FC, ReactNode } from 'react';
import { BOTTOM_SPACING_SCROLLVIEW, SPACING } from '../../config/designSystem/Spacing';
import { ContentSection } from './ContentSection';
import { FlatList, View } from 'react-native';
import { observer } from 'mobx-react';




export type LibraryWithAnyDataProps ={
    data: any,
    header: () => ReactNode,
    filterOutId?: string
    showAll?: boolean;
    displayButtonBelow?: boolean;
};

const _LibraryWithAnyData: FC<LibraryWithAnyDataProps> = ({data, header,filterOutId, showAll,displayButtonBelow}: LibraryWithAnyDataProps) => {

  const ref = React.useRef(null);
  useScrollToTop(ref);


  const renderCategory = ({ item }: any) => {
    if (item.data) {
      return (
        <ContentSection
          data={item.data}
          id={item.id}
          filterOutId={filterOutId}
          showAll={showAll}
          displayButtonBelow={displayButtonBelow}
        />
      );
    } else {
      return <View></View>;
    }
  };





  return (

    <FlatList
      ref={ref}
      data={data}
      keyExtractor={(item, index) => String(index)}
      renderItem={renderCategory}
      ListHeaderComponent={() => {
        return(
          <>{header()}
          </>);
      }}
      ListEmptyComponent={() => {return(<Loading />);}}
      contentContainerStyle={{ rowGap:SPACING['sp-32'], paddingBottom: BOTTOM_SPACING_SCROLLVIEW}}
    />
  );
};

export const LibraryWithAnyData = observer(_LibraryWithAnyData);
